import React, { memo, useMemo } from 'react';
import './AudioDbBarView.css';

const logToLinear = (x: number) => {
  const power = 100;
  return 100 * Math.pow(power, x / power);
};

interface AudioDbBarViewProps {
  value: number;
  minThreshold?: number;
  maxThreshold?: number;
}

const BarWrapper: React.FC<{ minThreshold: number; maxThreshold: number }> = memo(({ minThreshold, maxThreshold }) => {
  const minLog = useMemo(() => logToLinear(minThreshold), [minThreshold]);
  const maxLog = useMemo(() => logToLinear(maxThreshold), [maxThreshold]);

  console.log('rendering BarWrapper');
  return (
  <div className="bar-wrapper">
    <div
      className="bar-green"
      style={{ width: `${(minLog / 100) * 100}%` }}
    />
    <div
      className="bar-yellow"
      style={{
        width: `${((maxLog - minLog) / 100) * 100}%`,
      }}
    />
    <div className="bar-red" />
  </div>
  );
});

const BarLabels: React.FC = memo(() => (
  <div className="labels" style={{textAlign: 'left'}}>
    <span style={{ width: `${(logToLinear(-48) / 100) * 100}%` }}>-160</span>
    <span style={{ width: `${((logToLinear(-18) - logToLinear(-48)) / 100) * 100}%` }}>-48</span>
    <span style={{ width: `${((logToLinear(-12) - logToLinear(-18)) / 100) * 100}%` }}>-18</span>
    <span style={{ width: `${((logToLinear(-9) - logToLinear(-12)) / 100) * 100}%` }}>-12</span>
    <span style={{ width: `${((logToLinear(-6) - logToLinear(-9)) / 100) * 100}%` }}>-9</span>
    <span style={{ width: `${((logToLinear(-3) - logToLinear(-6)) / 100) * 100}%` }}>-6</span>
    <span style={{ width: `${((logToLinear(0) - logToLinear(-3)) / 100) * 100}%` }}>-3</span>
    <span>0</span>
  </div>
));

const AudioDbBarView: React.FC<AudioDbBarViewProps> = ({ value, minThreshold = -12, maxThreshold = -3 }) => {
  return (
    <div className="audio-db-bar-view">
      <div className="bar">
        <BarWrapper minThreshold={minThreshold} maxThreshold={maxThreshold} />
        <div className="bar-value" style={{ width: `${100 - (logToLinear(value) / 100 * 100)}%` }} />
      </div>
      <BarLabels />
    </div>
  );
};

export default AudioDbBarView;
